import { Controller } from "@hotwired/stimulus";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr";
export default class FlatpickrDateRangeController extends Controller {
  static targets = ["picker"];

  connect() {
    flatpickr(this.pickerTarget, {
      onChange: (selectedDates, dateStr, instance) => {},
      plugins: [
        ShortcutButtonsPlugin({
          button: [
            { label: "Today" },
            { label: "This Week" },
            { label: "This Month" },
          ],
          onClick: (index, fp) => {
            if (index === 0) {
              // today
              let date = new Date();
              fp.setDate([date, date], true);
              fp.close();
            } else if (index === 1) {
              // this week
              let prevMonday = new Date();
              let prevSunday = new Date();
              prevMonday.setDate(
                prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7),
              );
              prevSunday.setDate(prevMonday.getDate() + 6);
              fp.setDate([prevMonday, prevSunday], true);
              fp.close();
            } else if (index === 2) {
              // this month
              const currentMonth = new Date();
              const firstCurrentMonth = currentMonth.setDate(1);

              const now = new Date();
              const nextMonth = now.getMonth() === 11
                ? new Date(now.getFullYear() + 1, 0, 1)
                : new Date(now.getFullYear(), now.getMonth() + 1, 1);
              const lastCurrentMonth = nextMonth.setDate(0);
              fp.setDate([firstCurrentMonth, lastCurrentMonth], true);
              fp.close();
            }
          },
        }),
      ],
      dateFormat: "Y-M-d",
      mode: "range",
    });

    const shortcut_button = document.getElementsByClassName(
      "shortcut-buttons-flatpickr-buttons",
    );
    shortcut_button[0].classList.add("flex", "justify-between", "p-2");

    const shortcut_buttons = document.getElementsByClassName(
      "shortcut-buttons-flatpickr-button",
    );
    for (const shortcut_button of shortcut_buttons) {
      shortcut_button.classList.add(
        "bg-blue-500",
        "hover:bg-blue-700",
        "text-white",
        "font-bold",
        "py-2",
        "px-4",
        "border",
        "border-blue-700",
        "rounded",
      );
    }
  }
}
